import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { capitalize } from '@utils/string-utils';
import { OrderProtectionExtension, OrderProtectionFormGroup, WidgetConfigFormGroup } from '../../model';

@Component({
  selector: 'order-protection-appearance',
  templateUrl: './order-protection-appearance.component.html',
  styleUrls: ['./order-protection-appearance.component.scss'],
  standalone: false,
})
export class OrderProtectionAppearanceComponent {
  @Input() formGroup: FormGroup<OrderProtectionFormGroup>;

  get configGroup(): FormGroup<WidgetConfigFormGroup> {
    return this.formGroup.controls.config;
  }

  get showLogo(): boolean {
    return !this.configGroup.controls.hideLogo.value;
  }

  ActionType = OrderProtectionExtension.ActionType;

  readonly textSizeOptions = Object.values(OrderProtectionExtension.TextSize).map((value) => ({
    label: capitalize(value),
    value,
  }));
  readonly borderStyleOptions = Object.values(OrderProtectionExtension.BorderStyle).map((value) => ({
    label: capitalize(value),
    value,
  }));
  readonly borderWidthOptions = Object.values(OrderProtectionExtension.BorderWidth).map((value) => ({
    label: capitalize(value),
    value,
  }));
  readonly borderRadiusOptions = Object.values(OrderProtectionExtension.BorderRadius).map((value) => ({
    label: capitalize(value),
    value,
  }));
  readonly backgroundOptions = Object.values(OrderProtectionExtension.BackgroundColor).map((value) => ({
    label: capitalize(value),
    value,
  }));

  toggleBold(): void {
    const control = this.configGroup.controls.titleTextBold;
    control.setValue(!control.value);
  }

  onShowLogoToggle(showLogo: boolean): void {
    this.configGroup.controls.hideLogo.setValue(!showLogo);
  }
}
